const url = location.pathname;

if (url.indexOf('annex') != -1) {
  const changeAmenityImage = document.querySelector('.js-change-target img');
  changeAmenityImage.setAttribute('src', '/assets/images/icon/icon_locker.svg');
  
  const changeAmenityText = document.querySelector('.js-change-target .p-amenity__4col-text');
  changeAmenityText.innerHTML = '縦型<br class="u-sp">ロッカー';
}
